/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsroomguestsstillguest4Inputs */

const en_statsroomguestsstillguest4 = /** @type {(inputs: Statsroomguestsstillguest4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still without an account`)
};

const de_statsroomguestsstillguest4 = /** @type {(inputs: Statsroomguestsstillguest4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch ohne Konto`)
};

/**
* | output |
* | --- |
* | "Still without an account" |
*
* @param {Statsroomguestsstillguest4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsroomguestsstillguest4 = /** @type {((inputs?: Statsroomguestsstillguest4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsroomguestsstillguest4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsroomguestsstillguest4(inputs)
	return de_statsroomguestsstillguest4(inputs)
});
export { statsroomguestsstillguest4 as "statsRoomGuestsStillGuest" }